import GMaps from '../libs/gmaps/gmaps.min.js'
import MarkerClusterer from '@google/markerclustererplus'

export const agenciesMap = {
  buildMap: function (mapDiv) {
    const _this = this
    const datas = {}
    const markers = []
    let map
    let center

    const icon = document.location.origin + '/assets/img/icons/map-marker-offer-37x45.png'

    if ($('#region').length) {
      datas.region = $('#region').val()
    }
    if ($('#department').length) {
      datas.department = $('#department').val()
    }

    // if ( $map.find('input[name="department"]').length ) datas.department = $map.find('input[name="department"]').val()
    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: document.location.origin + '/nos-agences/listing',
      data: datas,
      success: function (response) {
        let countAgencies = 0
        let infowindow
        let marker
        const boxList = []

        // affiche les agences
        if (typeof response.agencies !== 'undefined') {
          /* global google */
          center = new google.maps.LatLng(47.2186371, -1.5541362)
          map = new google.maps.Map(mapDiv[0], {
            zoomControl: true,
            center: center,
            scrollwheel: false,
            streetViewControl: false,
            panControl: false,
            mapTypeControl: false,
            draggable: true,
            disableDoubleClickZoom: false,
            keyboardShortcuts: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP
          })
        }

        $.each(response.agencies, function (i, elem) {
          countAgencies++
          marker = new google.maps.Marker({
            id: i,
            position: new google.maps.LatLng(elem.lat, elem.lon),
            icon: icon,
            title: elem.name,
            address: elem.address,
            textColor: '#ffffff'
          })

          // infobulle
          const boxText = document.createElement('div')
          boxText.id = i
          boxText.data = elem
          boxText.innerHTML =
            '<div class="text-center text-fixed" id="content"><span class="h6 text-uppercase">' +
            elem.link +
            '</span><span class="my-2 d-block">' +
            elem.address +
            '</span>' +
            elem.phone +
            '<br>' +
            elem.btn +
            '</div>'
          boxList.push(boxText)
          infowindow = new google.maps.InfoWindow({
            enableEventPropagation: true
          })

          markers.push(marker)
          google.maps.event.addListener(
            marker,
            'click',
            (function (marker) {
              return function () {
                infowindow.setContent(boxList[this.id])
                infowindow.open(map, marker)
              }
            })(marker, i)
          )
        })

        const clusterStyles = [
          {
            textColor: '#222',
            textSize: '16',
            fontFamily: 'Poppins',
            url: 'assets/img/icons/m1.png',
            height: 52,
            width: 51
          },
          {
            textColor: '#222',
            textSize: '16',
            fontFamily: 'Poppins',
            url: 'assets/img/icons/m2.png',
            height: 56,
            width: 55
          },
          {
            textColor: '#222',
            textSize: '16',
            fontFamily: 'Poppins',
            url: 'assets/img/icons/m3.png',
            height: 65,
            width: 64
          },
          {
            textColor: '#222',
            textSize: '16',
            fontFamily: 'Poppins',
            url: 'assets/img/icons/m4.png',
            height: 78,
            width: 77
          },
          {
            textColor: '#222',
            textSize: '16',
            fontFamily: 'Poppins',
            url: 'assets/img/icons/m5.png',
            height: 90,
            width: 89
          }
        ]

        // dessine la carte ou affiche un message
        if (countAgencies > 0) {
          const m = new MarkerClusterer(map, markers, {
            styles: clusterStyles
            // imagePath: 'assets/img/icons/m',
          })
          // m.fitMapToMarkers()
          if (countAgencies === 1) {
            const listener = google.maps.event.addListener(map, 'idle', function () {
              // if (map.getZoom() > 16) map.setZoom(12)
              m.fitMapToMarkers()
              map.setZoom(10)
              google.maps.event.removeListener(listener)
            })
          } else {
            const listener = google.maps.event.addListener(map, 'idle', function () {
              m.fitMapToMarkers()
              map.setZoom(8)
              google.maps.event.removeListener(listener)
            })
          }
        }
      }
    })
  },

  init: function (mapDiv) {
    // Si map détail d'une agence
    if (mapDiv[0].id === 'map-detail') {
      const map = new GMaps({
        div: '#' + mapDiv.attr('id'),
        scrollwheel: false,
        lat: mapDiv.attr('map-lat'),
        lng: mapDiv.attr('map-lng')
      })
      const marker = map.addMarker({
        lat: mapDiv.attr('map-lat'),
        lng: mapDiv.attr('map-lng'),
        title: mapDiv.attr('map-title')
      })
      marker.setAnimation(google.maps.Animation.BOUNCE)
    } else {
      // sinon map globale
      this.buildMap(mapDiv)
    }
  }
}
